<template>
  <div class="update-password-wrapper">
    <div class="title">忘记密码</div>
    <a-form-model
      :model="passwordForm"
      ref="passwordForm"
      :rules="rules"
      class="login-form"
    >
      <a-form-model-item prop="phone">
        <a-input
          v-model="passwordForm.phone"
          placeholder="11位手机号"
          :size="formSize"
          @input="handleInputPhone"
        >
          <a-icon slot="prefix" type="mobile" style="color:rgba(0,0,0,.25)" />
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="code">
        <a-input-group>
          <a-input
            v-model="passwordForm.code"
            placeholder="验证码"
            :size="formSize"
            style="width: 62%;"
          >
            <a-icon slot="prefix" type="mail" style="color:rgba(0,0,0,.25)" />
          </a-input>
          <a-button
            style="width:33%;margin-left:5%;"
            :size="formSize"
            :loading="codeLoading"
            type="primary"
            :disabled="!canSendCode"
            @click="handleSendCode"
            >{{ codeText }}</a-button
          >
        </a-input-group>
      </a-form-model-item>
      <a-form-model-item prop="password">
        <a-input-password
          :size="formSize"
          v-model="passwordForm.password"
          type="password"
          placeholder="6 - 16 位密码，区分大小写"
        >
          <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
        </a-input-password>
      </a-form-model-item>
      <a-form-model-item prop="confirmPassword">
        <a-input-password
          :size="formSize"
          v-model="passwordForm.confirmPassword"
          type="password"
          placeholder="确认密码"
        >
          <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
        </a-input-password>
      </a-form-model-item>
      <a-form-model-item>
        <a-button
          type="primary"
          :size="formSize"
          @click="handleSubmit"
          style="width: 176px;"
          :loading="loading"
        >
          确定
        </a-button>
        <a-button
          style="float: right;top:8px;"
          type="link"
          size="small"
          @click="handleLogin"
        >
          账户登录
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { checkPhone } from "@/utils/validate";
import { getCode } from "@/api/common";
import { updatePwd } from "@/api/user";
import { showMessage } from "@/utils/message";

export default {
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (value.length < 6) {
        callback(new Error("密码长度不小于6个字符"));
      } else {
        if (this.passwordForm.confirmPassword !== "") {
          this.$refs.passwordForm.validateField("confirmPassword");
        }
        callback();
      }
    };
    let validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入确认密码"));
      } else if (value.length < 6) {
        callback(new Error("确认密码长度不小于6个字符"));
      } else if (value !== this.passwordForm.password) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    };
    return {
      passwordForm: {
        phone: "",
        code: "",
        password: "",
        confirmPassword: ""
      },
      rules: {
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur"
          }
        ],
        code: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            validator: validatePass,
            trigger: "blur"
          }
        ],
        confirmPassword: [
          {
            required: true,
            validator: validatePass2,
            trigger: "blur"
          }
        ]
      },
      canSendCode: false,
      codeText: "获取验证码",
      loading: false,
      codeLoading: false
    };
  },
  computed: {
    ...mapGetters(["formSize"])
  },
  methods: {
    ...mapActions({
      login: "Login"
    }),
    handleSubmit() {
      this.$refs.passwordForm.validate(valid => {
        if (valid) {
          this.loading = true;
          updatePwd(this.passwordForm)
            .then(() => {
              showMessage("success", "密码修改成功");
              const timeout = setTimeout(() => {
                this.$router.push({ name: "Login" });
                clearTimeout(timeout);
              }, 1000);
            })
            .catch(e => {
              console.error(e);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    handleInputPhone() {
      if (checkPhone(this.passwordForm.phone)) {
        this.canSendCode = true;
      } else {
        this.canSendCode = false;
      }
    },
    handleSendCode() {
      if (this.canSendCode) {
        this.canSendCode = false;
        this.codeLoading = true;
        getCode({ phone: this.passwordForm.phone })
          .then(res => {
            console.log(res);
            showMessage("success", "验证码发送成功");
            let timer = 60;
            const inter = setInterval(() => {
              this.codeText = `${timer} s`;
              --timer;
              if (timer < 0) {
                this.canSendCode = true;
                clearInterval(inter);
                this.codeText = "获取验证码";
              }
            }, 1000);
          })
          .catch(e => {
            console.error(e);
          })
          .finally(() => {
            this.codeLoading = false;
          });
      }
    },
    handleLogin() {
      this.$router.push({ name: "Login" });
    }
  }
};
</script>
<style lang="less" scoped>
.update-password-wrapper {
  min-height: 380px;
  .title {
    font-size: 16px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    width: 365px;
    margin: 0 auto 20px;
  }

  .login-form {
    width: 375px;
    padding: 0 5px;
    box-sizing: border-box;
    margin: 0 auto;
  }
}
</style>
